import { footAbout, footChannels } from "@/mocks/leakData";

export default function Footer() {
  return (
    <footer className="bg-background-200/70 text-secondary-700">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#headline" className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 font-heading text-xl font-black text-background-50">
                98
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">
                98<span className="text-primary-600">爆料</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-600">
              专注于独家信源挖掘，汇聚匿名投稿与内部线人第一手猛料。以双源交叉核验为门槛，守护每一个别处看不到的真相。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-secondary-500">
              <i className="ri-shield-check-line text-primary-600" />
              线索保护 · 双重核验 · 匿名优先
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-sm font-bold text-foreground-950">快速栏目</h3>
            <ul className="mt-4 space-y-2.5">
              {footChannels.map((c) => (
                <li key={c.label}>
                  <a href={c.href} className="text-sm text-secondary-600 transition hover:text-primary-600">
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-sm font-bold text-foreground-950">了解我们</h3>
            <ul className="mt-4 space-y-2.5">
              {footAbout.map((a) => (
                <li key={a}>
                  <a href="#submit" className="text-sm text-secondary-600 transition hover:text-primary-600">
                    {a}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-sm font-bold text-foreground-950">获取抢先更新</h3>
            <p className="mt-3 text-xs leading-relaxed text-secondary-500">
              订阅后将第一时间收到抢先版内幕与信源补充进度。
            </p>
            <a
              href="#submit"
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-700"
            >
              <i className="ri-mail-send-line" />
              开启订阅提醒
            </a>
          </div>
        </div>

        <div className="mt-10 border-t border-background-300/70 pt-5">
          <p className="text-xs leading-relaxed text-secondary-500">
            本页面为静态展示示例。98爆料所载内容均基于多方线索与公开资料整理，观点不代表本站立场；相关事实以权威披露为准，如涉及侵权请通过投稿通道联系处理。
          </p>
          <div className="mt-3 flex flex-col items-start justify-between gap-2 text-xs text-secondary-400 sm:flex-row sm:items-center">
            <span>© 2026 98爆料 · 第一手内幕 抢先版速递</span>
            <span>独家消息 / 内部信源 / 匿名投稿</span>
          </div>
        </div>
      </div>
    </footer>
  );
}